type LoggedError = {
  uuid: string;
  name: string;
  message: string;
  stack?: string;
};

type ErrorState = {
  latestEventTime: number;
  latestErrorUUID: string;
  stateName: string;
  errors: Array<LoggedError>;
  maxErrorHistory: number;
};

const defaultState: ErrorState = {
  latestEventTime: null,
  latestErrorUUID: null,
  stateName: null,
  errors: [],
  maxErrorHistory: 10,
};

export { defaultState, ErrorState, LoggedError };
